/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TreatmentPlanDto } from './TreatmentPlanDto';
import {
    TreatmentPlanDtoFromJSON,
    TreatmentPlanDtoFromJSONTyped,
    TreatmentPlanDtoToJSON,
    TreatmentPlanDtoToJSONTyped,
} from './TreatmentPlanDto';
import type { PaginationDto } from './PaginationDto';
import {
    PaginationDtoFromJSON,
    PaginationDtoFromJSONTyped,
    PaginationDtoToJSON,
    PaginationDtoToJSONTyped,
} from './PaginationDto';

/**
 * 
 * @export
 * @interface TreatmentPlanListResponseDto
 */
export interface TreatmentPlanListResponseDto {
    /**
     * List of treatment plans
     * @type {Array<TreatmentPlanDto>}
     * @memberof TreatmentPlanListResponseDto
     */
    treatmentPlans?: Array<TreatmentPlanDto>;
    /**
     * Pagination information
     * @type {PaginationDto}
     * @memberof TreatmentPlanListResponseDto
     */
    pagination: PaginationDto;
}

/**
 * Check if a given object implements the TreatmentPlanListResponseDto interface.
 */
export function instanceOfTreatmentPlanListResponseDto(value: object): value is TreatmentPlanListResponseDto {
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function TreatmentPlanListResponseDtoFromJSON(json: any): TreatmentPlanListResponseDto {
    return TreatmentPlanListResponseDtoFromJSONTyped(json, false);
}

export function TreatmentPlanListResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TreatmentPlanListResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'treatmentPlans': json['treatmentPlans'] == null ? undefined : ((json['treatmentPlans'] as Array<any>).map(TreatmentPlanDtoFromJSON)),
        'pagination': PaginationDtoFromJSON(json['pagination']),
    };
}

export function TreatmentPlanListResponseDtoToJSON(json: any): TreatmentPlanListResponseDto {
    return TreatmentPlanListResponseDtoToJSONTyped(json, false);
}

export function TreatmentPlanListResponseDtoToJSONTyped(value?: TreatmentPlanListResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'treatmentPlans': value['treatmentPlans'] == null ? undefined : ((value['treatmentPlans'] as Array<any>).map(TreatmentPlanDtoToJSON)),
        'pagination': PaginationDtoToJSON(value['pagination']),
    };
}

